module.exports = __webpack_public_path__ + "img/intellisurvey.ae3bc878.png";